import TripItemRailRecommendation from './trip-item-rail-recommendation-component';
import TripItemRailRecommendationService from './trip-item-rail-recommendation-service';
import './trip-item-rail-recommendation.scss';

const MODULE_NAME = 'app.trip.item-rail-recommendation';
const module = angular.module(MODULE_NAME, [])
    .directive(TripItemRailRecommendation.DIRECTIVE_NAME, TripItemRailRecommendation)
    .service('tripItemRailRecommendationService', TripItemRailRecommendationService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-recommendation/trip-item-rail-recommendation/trip-item-rail-recommendation-module.js